<template>
  <CardHeaderTips
    :main-text="`正在${tipsText}中`"
    normal-text="，预计 2~3 分钟，无需在此等待"
    style="margin-left: -12px"
  />
  <div v-loading="loading" class="meeting-reminder">
    <div class="header" :style="{ 'margin-bottom': autoWarehouseType ? '0' : '16px' }">
      <div class="tip">
        <i class="icon-checkbox-circle-fill t-iconfont"></i>
        <h3 class="tip-title">{{ tipsText }}完成</h3>
      </div>
    </div>

    <div class="content-card">
      <div v-if="!autoWarehouseType" class="client-section">
        <div class="section-title">本次跟进对象<span class="requireTip">*</span></div>
        <div class="wrapper">
          <template v-if="isMobile()">
            <MobileSelectTrigger
              :columns="followUpObjectPickerColumns"
              :disabled="disabledSelect"
              inline
              :label="selectedFollowUpObjectLabel"
              :picker-value="followUpObjectPickerValue"
              title="选择跟进对象"
              :wrapper-style="{ maxWidth: '90px' }"
              @confirm="handleFollowUpObjectPickerConfirm"
            />
          </template>
          <el-select
            v-else
            v-model="followUpObject"
            :disabled="disabledSelect"
            placeholder="请选择"
            style="width: 104px; margin-right: 8px; flex: 0 0 auto"
          >
            <el-option
              v-for="item in followUpObjectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- 线索选择 -->
          <template v-if="showClue">
            <MobileClueSelect
              v-if="isMobile()"
              v-model="clue"
              :disabled="disabledSelect"
              @change="handleFollowUpClueChange"
            />
            <ClueSelect
              v-else
              v-model="clue"
              :disabled="disabledSelect"
              @change="handleFollowUpClueChange"
            />
          </template>
          <!-- 客户选择 -->
          <template v-else>
            <div class="client-selector">
              <template v-if="isCustomerHistory && !attributes.item.shortcutRefId">
                <el-select v-model="customer" disabled filterable>
                  <el-option
                    v-for="option in customerList"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id"
                  />
                </el-select>
              </template>
              <template v-else>
                <CustomerSelectLocation
                  v-if="isMobile()"
                  ref="customerSelectRef"
                  v-model="customer"
                  :disabled="disabledSelect"
                  :is-location="isLocation && !inxbb"
                  @addCustomer="handleAddCustomer"
                  @change="handleFollowUpCustomerChange"
                />
                <CustomerSelect
                  v-else
                  ref="customerSelectRef"
                  v-model="customer"
                  :disabled="disabledSelect"
                  @addCustomer="handleAddCustomer"
                  @change="handleFollowUpCustomerChange"
                />
              </template>
            </div>
          </template>
        </div>
      </div>

      <div
        v-if="showDetailInfo"
        ref="tabContentRef"
        class="tab-content"
        :class="{ 'is-show-limit': tabContentHeight > 288 && !showMore }"
      >
        <template v-if="isLiberalRules">
          <div class="section">
            <div v-if="isContentTooLong" class="content-warning">
              <div class="warning-icon">⚠️</div>
              <div class="warning-text">内容过长，为保证性能已自动截取前部分内容</div>
            </div>
            <MarkdownView :show-string="processedSummaryContent" />
          </div>
        </template>
        <template v-else>
          <div v-for="(item, index) in summary.contentsItems" :key="index" class="section">
            <div class="section-header">
              <img class="icon" :src="meetingIcon" />
              <span>{{ item.name }}</span>
            </div>
            <ul class="section-list">
              <li
                v-for="(it, i) in item.items"
                :key="i"
                :class="{ 'is-column-layout': isMobile() }"
              >
                <span class="item-label">
                  <div class="circle"></div>
                  {{ it.name }}
                </span>
                <span class="item-value">{{ it.result }}</span>
              </li>
            </ul>
          </div>
        </template>
        <div v-if="tabContentHeight > 288 && !showMore" class="show-more" @click="showMore = true">
          <span class="text">查看全部</span>
        </div>
      </div>
    </div>
    <el-button
      v-if="!autoWarehouseType"
      color="#7a52f4"
      :disabled="hiddenBtn"
      style="width: 100%; margin-top: 12px"
      @click="handleIntoStore"
    >
      <i class="icon-check-line t-iconfont" style="margin-right: 4px"></i>
      {{ hiddenBtn ? '已入库' : '跟进入库' }}
    </el-button>
    <template v-if="isMobile()">
      <AiUseXbbForm
        v-if="url && showXbb"
        v-model:loading="iframeLoading"
        v-model:show-xbb="showXbb"
        :xbb-url="url"
        @handleXbbSuccess="handleXbbSuccess"
      />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onBeforeUnmount, nextTick, watch } from 'vue'
import { ElMessage } from 'element-plus'
import CustomerSelect from '../CustomerSelect.vue'
import CustomerSelectLocation from '../CustomerSelectLocation.vue'
import ClueSelect from '../ClueSelect.vue'
import MobileClueSelect from '../MobileClueSelect.vue'
import MobileSelectTrigger from '@/components/MobileSelectTrigger.vue'
import { addCustomerCommunicate, getCustomRecordInfo } from '@/api'
import meetingIcon from '@/assets/meeting-analyse-icon.png'
import { isMobile } from '@/utils'
import { useAppStore } from '@/store/useAppStore'
import xbbSdk from 'xbb-sdk'
import CardHeaderTips from '@/components/Cards/components/card-header-tips.vue'
import xbb from '@xbb/xbb-utils'
import MarkdownView from '@/components/markdown-view/index.vue'
import { BUSINESS_TYPE } from '@/config/config.js'
import AiUseXbbForm from '@/components/ai-use-xbbform/index.vue'

const emit = defineEmits(['addMessage', 'refreshList', 'preview', 'scrollEnd'])

const props = defineProps({
  attributes: {
    type: Object,
    default: () => ({})
  },
  mobileToken: {
    type: String,
    default: ''
  },
  isLocation: {
    type: Boolean,
    default: false
  }
})

// 加载中状态
const loading = ref(true)
// 是否客户历史数据
const isCustomerHistory = ref(true)
// 是否展示线索选择器
const showClue = ref(false)
// 跟进对象(默认100: 客户)
const followUpObject = ref(BUSINESS_TYPE.CUSTOMER)
// 跟进对象列表
const followUpObjectList = ref([])
// 客户列表
const customerList = ref([])
// 提炼详情是否展示
const viewMeetingTag = ref(true)
// 是否自动入库数据
const autoWarehouseType = ref(true)
// 卡片提示语关键字
const tipsText = computed(() => {
  return props.attributes.isMedicalIndustry === 1 || !autoWarehouseType.value ? '分析' : '入库'
})
const customerSelectRef = ref(null)
// 客户字段缓存值（仅提交时使用）
const customerSubmitCache = ref(null)
// 线索
const clue = ref(null)
// 线索字段缓存值（仅提交时使用）
const clueSubmitCache = ref(null)
const customer = ref(null)
const hiddenBtn = ref(false)
// 是否禁用选择器
const disabledSelect = computed(() => {
  return +props.attributes.storeTag === 1 || hiddenBtn.value
})
const selectedFollowUpObjectLabel = computed(
  () => followUpObjectList.value.find((item) => +item.value === +followUpObject.value)?.label || ''
)
const followUpObjectPickerColumns = computed(() =>
  followUpObjectList.value.map((item) => ({ text: item.label, value: item.value }))
)
const followUpObjectPickerValue = computed(() =>
  followUpObject.value === undefined || followUpObject.value === null ? [] : [followUpObject.value]
)
const showXbb = ref(false)
const url = ref('')
const tabContentRef = ref(null)
const tabContentHeight = ref(0)
const showMore = ref(false)

const inxbb = ref(false)

const isInit = ref(true)

const isLiberalRules = computed(() => {
  return xbb._get(props.attributes, 'summary.isLiberalRules', 0)
})

// 检查内容是否过长
const isContentTooLong = computed(() => {
  const content = summary.value?.content || ''
  return content.length > 5000 // 超过5000字符认为过长
})

// 处理后的内容，截取前部分并清理嵌套markdown
const processedSummaryContent = computed(() => {
  const content = summary.value?.content || ''
  if (!content) return ''

  let processed = content

  // 如果内容过长，截取前5000字符
  if (processed.length > 5000) {
    processed = processed.substring(0, 5000) + '\n\n...内容过长，已自动截取'
  }

  // 清理嵌套的markdown代码块
  processed = processed
    .replace(/```markdown\s*\n([\s\S]*?)\n```/g, '$1')
    .replace(/```([\s\S]*?)```/g, (match, code) => {
      // 如果代码块内容过长，也进行截取
      if (code.length > 1000) {
        return '```\n' + code.substring(0, 1000) + '\n...代码过长，已截取\n```'
      }
      return match
    })

  return processed
})

const summary = computed(() => {
  return props.attributes.summary || props.attributes
})

// 是否展示详细会议提炼内容
const showDetailInfo = computed(() => {
  if (viewMeetingTag.value === false) {
    return false
  }
  return true
})

const sendXbbParams = ref({})
const iframeLoading = ref(false)

/**
 *
 * @param param0
 * @param param0.chatRecordId 跟进记录id
 * @param param0.customerId 客户id
 * @param param0.type 业务类型
 * @param param0.clueId 线索id
 * @param param0.useAiPosition 是否使用AI位置, 不为1则使用销帮帮新建自带的定位
 */
async function getUrl({ chatRecordId, customerId, type, clueId, useAiPosition }) {
  // const frontUrl = 'https://saetestdingtalkf.xbongbong.com.cn/pro/index.html'
  // const frontUrl = 'http://192.168.21.198:8080'
  // const frontUrl = 'http://localhost:8081'
  const path = 'application/newForm'
  const aiPosition = useAiPosition === 1 ? '&useAiPosition=1' : ''
  const res = await getCustomRecordInfo({ businessType: type })
  let url = ''
  const { appId, menuId, formId, businessType, subBusinessType, frontUrl } = res.result

  const commonUrlPre = `${frontUrl}?isAi=1${aiPosition}`
  const commonUrlMiddle = `#/${path}?appId=${appId}&menuId=${menuId}&formId=${formId}&saasMark=1&distributorMark=0&businessType=${businessType}`
  const commonUrlTail = `&timestamp=${new Date().getTime()}&isAiRoot=1`

  if (+followUpObject.value === BUSINESS_TYPE.CUSTOMER) {
    if (chatRecordId && customerId) {
      // 跟进记录需要触发填值逻辑，所填的值需要通过chatRecordId和customerId查询
      url = `${commonUrlPre}&chatRecordId=${chatRecordId}&customerId=${customerId}${commonUrlMiddle}&subBusinessType=${subBusinessType}${commonUrlTail}`
    } else {
      url = `${commonUrlPre}${commonUrlMiddle}&subBusinessType=${subBusinessType}${commonUrlTail}`
    }
  } else if (+followUpObject.value === BUSINESS_TYPE.CLUE) {
    if (chatRecordId && clueId) {
      url = `${commonUrlPre}&chatRecordId=${chatRecordId}&dataId=${clueId}&businessType=${followUpObject.value}${commonUrlMiddle}&subBusinessType=${subBusinessType}&linkBusinessType=${BUSINESS_TYPE.CLUE}&isLinkAdd=1&isDetailAdd=1${commonUrlTail}`
    } else {
      // TODO
    }
  }

  console.log('url = ', url)
  return url
}

const getParams = async (type) => {
  const res = await getCustomRecordInfo({ businessType: type })
  const { appId, menuId, formId, businessType, subBusinessType } = res.result
  return { appId, menuId, formId, businessType, subBusinessType }
}

/**
 * 处理销帮帮成功回调 （移动端）
 * @param e
 */
const handleXbbSuccess = (e) => {
  let _dataId = ''
  if (+followUpObject.value === BUSINESS_TYPE.CUSTOMER) {
    _dataId = customerSubmitCache.value?.id
  } else if (+followUpObject.value === BUSINESS_TYPE.CLUE) {
    _dataId = clueSubmitCache.value?.id
  }

  const someParams = {
    dataId: _dataId,
    chatRecordId: props.attributes?.id,
    businessType: followUpObject.value
  }
  useAppStore().setIsXbbIframeShow(false)
  showXbb.value = false
  const params = e.data.params
  if (+params.businessType === BUSINESS_TYPE.CUSTOMER_COMMUNICATE) {
    addCustomerCommunicate({
      customerCommunicateId: e.data.dataId,
      ...someParams
    }).then(async (res) => {
      hiddenBtn.value = true
      emit('refreshList')
    })
  } else if (+params.businessType === BUSINESS_TYPE.CUSTOMER) {
    customerSubmitCache.value = {
      id: e.data.dataId,
      name: params.dataList.text_1
    }
    customerSelectRef.value.getList()
  }
}

/**
 * 处理销帮帮成功回调 （web端）
 * @param e
 */
const xbbIframeWeb = (e) => {
  let _dataId = ''
  if (+followUpObject.value === BUSINESS_TYPE.CUSTOMER) {
    _dataId = customerSubmitCache.value?.id
  } else if (+followUpObject.value === BUSINESS_TYPE.CLUE) {
    _dataId = clueSubmitCache.value?.id
  }

  const someParams = {
    dataId: _dataId,
    chatRecordId: props.attributes?.id,
    businessType: followUpObject.value
  }
  if (e.data?.type === 'aiSuccessWeb') {
    const params = e.data.data
    const result = e.data.result

    // 校验是否是当前表单 因为销帮帮可以关联新建
    if (
      params.appId === sendXbbParams.value.appId &&
      params.menuId === sendXbbParams.value.menuId &&
      params.formId === sendXbbParams.value.formId &&
      params.businessType === sendXbbParams.value.businessType
    ) {
      if (+params.businessType === BUSINESS_TYPE.CUSTOMER_COMMUNICATE) {
        addCustomerCommunicate({
          customerCommunicateId: result.dataId,
          ...someParams
        }).then(async (res) => {
          hiddenBtn.value = true
          emit('refreshList')
        })
      } else if (+params.businessType === BUSINESS_TYPE.CUSTOMER) {
        customerSelectRef.value.getList()
        customerSubmitCache.value = {
          id: result.dataId,
          name: params.dataList.text_1
        }
      }
    }
  }
}

// 兼容新版选择器只更新 v-model、未同步提交缓存的情况
const normalizeFollowUpTarget = (value) => {
  if (!value || typeof value !== 'object') return null
  const id = value.id ?? value.customerId ?? value.value
  if (!id) return null
  return {
    id,
    name: value.name ?? value.customerName ?? value.label,
    required: true
  }
}

/**
 * 处理客户变更
 * @param value 所选值
 */
const handleFollowUpCustomerChange = (value) => {
  customerSubmitCache.value = normalizeFollowUpTarget(value)
}
const handleFollowUpObjectPickerConfirm = ({ selectedValues }) => {
  const value = selectedValues?.[0]
  if (value === undefined) return
  followUpObject.value = value
}
/**
 * 处理线索变更
 * @param value 所选值
 */
const handleFollowUpClueChange = (value) => {
  clueSubmitCache.value = normalizeFollowUpTarget(value)
}
const handleAddCustomer = async () => {
  console.log('新建客户')
  if (isMobile() || !inxbb.value) {
    console.log('调用移动端新建')
    url.value = await getUrl({
      type: BUSINESS_TYPE.CUSTOMER,
      useAiPosition: 1
    })
    iframeLoading.value = true
    if (!isMobile()) {
      customerSelectRef.value.dropdownRef.handleClose()
    }
    useAppStore().setIsXbbIframeShow(true)
    showXbb.value = true
  } else {
    console.log('调用PC端新建')
    const params = await getParams(BUSINESS_TYPE.CUSTOMER)
    sendXbbParams.value = {
      appId: params.appId,
      menuId: params.menuId,
      formId: params.formId,
      saasMark: 1,
      businessType: params.businessType,
      subBusinessType: params.subBusinessType
    }
    xbbSdk.sendMessage('addNewForm', {
      appId: params.appId,
      menuId: params.menuId,
      formId: params.formId,
      saasMark: 1,
      businessType: params.businessType,
      subBusinessType: params.subBusinessType
    })
    if (!isMobile()) {
      customerSelectRef.value.dropdownRef.handleClose()
    }
  }
}

const handleIntoStore = async () => {
  let dataId = ''
  const followUpValue = +followUpObject.value

  if (followUpValue === BUSINESS_TYPE.CUSTOMER || followUpValue === BUSINESS_TYPE.CLUE) {
    const targetCache =
      followUpValue === BUSINESS_TYPE.CUSTOMER ? customerSubmitCache.value : clueSubmitCache.value
    const targetModel = followUpValue === BUSINESS_TYPE.CUSTOMER ? customer.value : clue.value
    // 优先使用提交缓存，缓存缺失时用选择器当前值兜底
    const target = normalizeFollowUpTarget(targetCache) || normalizeFollowUpTarget(targetModel)
    console.log('targetCache:', followUpValue, customerSubmitCache, clueSubmitCache)
    if (target?.id) {
      dataId = target.id
      if (followUpValue === BUSINESS_TYPE.CUSTOMER) {
        customerSubmitCache.value = target
      } else {
        clueSubmitCache.value = target
      }
    } else {
      ElMessage.error('请选择本次跟进对象')
      return
    }
  }

  if (isMobile() || !inxbb.value) {
    url.value = await getUrl({
      chatRecordId: props.attributes.id,
      customerId: dataId,
      clueId: dataId,
      type: BUSINESS_TYPE.CUSTOMER_COMMUNICATE,
      useAiPosition: 1
    })

    iframeLoading.value = true

    useAppStore().setIsXbbIframeShow(true)
    showXbb.value = true
  } else {
    const params = await getParams(BUSINESS_TYPE.CUSTOMER_COMMUNICATE)
    const someParams = {
      appId: params.appId,
      menuId: params.menuId,
      formId: params.formId,
      saasMark: 1
    }
    let _sendXbbParams = {}
    if (+followUpObject.value === BUSINESS_TYPE.CUSTOMER) {
      _sendXbbParams = {
        businessType: params.businessType,
        subBusinessType: params.subBusinessType,
        chatRecordId: props.attributes.id,
        customerId: dataId,
        ...someParams
      }

      xbbSdk.sendMessage('addNewForm', _sendXbbParams)
    } else if (+followUpObject.value === BUSINESS_TYPE.CLUE) {
      _sendXbbParams = {
        dataIdList: [dataId],
        businessType: BUSINESS_TYPE.CUSTOMER_COMMUNICATE,
        linkBusinessType: BUSINESS_TYPE.CLUE,
        chatRecordId: props.attributes.id,
        formType: 'linkDataForm',
        ...someParams
      }
      xbbSdk.sendMessage('addNewForm', _sendXbbParams)
    }
    sendXbbParams.value = { ..._sendXbbParams }
  }
}

const environmentInit = () => {
  // 获取完整 URL 中的搜索参数部分（即 "?inxbb=1"）
  const searchParams = new URLSearchParams(window.location.search)
  // 通过参数名 "inxbb" 获取对应的值
  const inxbbValue = searchParams.get('inxbb') || ''
  inxbb.value = +inxbbValue === 1
}

const initData = () => {
  loading.value = true

  const attributes = props.attributes
  const _customer = attributes.customer
  const _businessType = attributes?.businessType || _customer?.businessType

  viewMeetingTag.value = attributes.viewMeetingTag
  autoWarehouseType.value = attributes.autoWarehouseType
  // 设置入库按钮是否可用
  if (attributes.storeTag) {
    hiddenBtn.value = true
  }

  // 处理已操作数据和未操作数据(storeTag: 0 未入库； 1 已入库)
  if (+attributes.storeTag) {
    // 设置跟进对象
    followUpObject.value = _businessType
    followUpObjectList.value = [
      {
        value: _businessType,
        label: _businessType === BUSINESS_TYPE.CUSTOMER ? '客户' : '线索'
      }
    ]

    const itemInfo = {
      id: _customer.customerId,
      name: _customer.customerName
    }
    if (_businessType === BUSINESS_TYPE.CLUE) {
      // 设置线索信息
      clue.value = itemInfo
    } else if (_businessType === BUSINESS_TYPE.CUSTOMER) {
      // 设置客户信息
      customer.value = itemInfo
      customerList.value = [itemInfo]
      customerSubmitCache.value = itemInfo
      isCustomerHistory.value = true
    }
  } else {
    console.log('🍊', '未入库', attributes)
    isCustomerHistory.value = false
    // 入库方式配置信息
    const _storageConfigInfo = attributes.storageConfigInfo || null
    if (_storageConfigInfo) {
      // 设置跟进对象
      const _followUpObject = +_storageConfigInfo.followUpObject || null
      followUpObject.value = _followUpObject
      // 处理跟进对象特殊值
      if (!_followUpObject || _followUpObject === BUSINESS_TYPE.SPECIAL) {
        followUpObject.value = BUSINESS_TYPE.CUSTOMER
      }

      const customerItem = {
        value: BUSINESS_TYPE.CUSTOMER,
        label: '客户'
      }
      const _businessTypes = _storageConfigInfo.businessTypes
      if (_businessTypes) {
        followUpObjectList.value = _businessTypes?.map((item) => {
          if (item === BUSINESS_TYPE.CUSTOMER) {
            return customerItem
          }
          return {
            value: BUSINESS_TYPE.CLUE,
            label: '线索'
          }
        })
      } else {
        followUpObjectList.value = [customerItem]
      }
    }

    // 如果是快捷新建-手动新建的，需要回显
    if (attributes.item.shortcutRefType) {
      followUpObject.value = attributes.item.shortcutRefType
      const itemInfo = {
        id: attributes.item.shortcutRefId,
        name: attributes.item.shortcutRefName
      }
      if (attributes.item.shortcutRefType === BUSINESS_TYPE.CLUE) {
        // 设置线索信息
        clue.value = itemInfo
        clueSubmitCache.value = itemInfo
      } else if (attributes.item.shortcutRefType === BUSINESS_TYPE.CUSTOMER) {
        // 设置客户信息
        customer.value = itemInfo
        customerList.value = [itemInfo]
        customerSubmitCache.value = itemInfo
        isCustomerHistory.value = true
      }
    }
  }

  loading.value = false
}

// 监听customer变化，更新showClue
watch(
  () => followUpObject.value,
  (newVal) => {
    customerSubmitCache.value = undefined
    customer.value = undefined
    if (!isInit.value) {
      clueSubmitCache.value = undefined
      clue.value = null
    }
    isInit.value = false

    if (+newVal === BUSINESS_TYPE.CLUE) {
      showClue.value = true
    } else {
      showClue.value = false
    }
  }
)

onMounted(() => {
  initData()
  environmentInit()

  window.addEventListener('message', xbbIframeWeb)
  nextTick(() => {
    if (showDetailInfo.value) {
      // 获取tabContentRef的高度
      tabContentHeight.value = tabContentRef.value.clientHeight
    }
  })
})

onBeforeUnmount(() => {
  useAppStore().setIsXbbIframeShow(false)
  window.removeEventListener('message', xbbIframeWeb)
})
</script>

<style lang="less" scoped>
.meeting-reminder {
  box-sizing: border-box;
  max-width: 400px;
  overflow-x: scroll;
  border-radius: 8px;
  background: #fff;
  padding: 12px;
  margin: -12px;
}

.header {
  .tip {
    display: flex;
    align-items: center;

    &-title {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0em;
      color: #323233;
    }

    .icon-checkbox-circle-fill {
      color: #00c241;
      margin-right: 8px;
    }
  }

  p {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: -0.01em;
    color: #969799;
  }
}

.summary {
  margin-bottom: 16px;
  color: #323233;

  p {
    font-size: 14px;
    line-height: 1.5;
    margin: 0;

    .bold {
      font-weight: 600;
    }
  }

  .emoji {
    font-size: 18px;
  }
}

.content-card {
  // background-color: #fff;
  // border-radius: 8px;
  // overflow: hidden;
  // margin-bottom: 16px;
  // border: 1px solid #e5e6eb;

  .client-section {
    // padding: 16px 16px 12px;

    .wrapper {
      display: flex;
      gap: 8px;
      :deep(.el-form-item__label::after) {
        content: '*';
        color: red;
        margin-left: 4px;
      }
      :deep(.el-form-item__content) {
        display: flex;
        flex-wrap: nowrap;
      }
    }

    .section-title {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 8px;
      .requireTip {
        color: var(--el-color-danger);
        margin-left: 4px;
      }
    }

    .error-info {
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #f54e4e;
      margin-top: 4px;
    }

    .client-selector {
      position: relative;
      display: flex;
      align-items: center;
      width: 264px;

      .customer-select {
        margin-right: 8px;
      }

      .client-name {
        flex: 1;
        font-size: 14px;
      }

      .dropdown-icon {
        color: #999;
        margin-right: 16px;

        .arrow {
          font-size: 12px;
        }
      }

      .check-icon {
        width: 20px;
        height: 20px;
        background-color: #52c41a;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .check {
          font-size: 12px;
        }
      }
    }
  }

  .tab-bar {
    display: flex;
    // padding: 0 12px;

    .tab {
      text-align: center;
      // padding: 12px 0;
      margin: 0 16px;
      font-size: 14px;
      color: #646566;
      position: relative;
      border-bottom: 2px solid transparent;
      cursor: pointer;

      &.active {
        font-weight: 600;
        color: #323233;
        border-bottom: 2px solid #248df5;
      }
    }
  }

  .tab-content {
    position: relative;
    // padding: 0 16px 16px;
    margin-top: 12px;

    .meeting-content {
      font-size: 14px;
      font-weight: 600;
      margin: 8px 0;
      position: relative;
      padding-left: 12px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 4px;
        height: 12px;
        background-color: #248df5;
        border-radius: 4px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .meeting-details {
      margin-bottom: 16px;

      .meeting-item {
        display: flex;
        padding: 8px 0;
        font-size: 14px;

        .item-label {
          width: 84px;
          color: #646566;
        }

        .item-value {
          flex: 1;
          color: #323233;

          &.link {
            color: #248df5;
            cursor: pointer;
          }
        }
      }
    }

    .section {
      margin-bottom: 8px;
      background: #f7f8fa;
      border-radius: 8px;
      padding: 8px;

      .section-header {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      .section-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          display: flex;
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 1.5;

          .circle {
            height: 4px;
            width: 4px;
            border-radius: 2px;
            background-color: #248df5;
            margin: 8px;
          }

          .role,
          .item-label {
            display: flex;
            min-width: 104px;
            color: #646566;
            margin-right: 12px;
          }

          .person,
          .item-value {
            flex: 1;
            color: #323233;
          }
        }
        .is-column-layout {
          flex-direction: column;
          .item-value {
            margin-left: 20px;
          }
        }
      }
    }
  }

  .is-show-limit {
    height: 288px;
    overflow: hidden;
    margin-bottom: 16px;
    position: relative;
    .show-more {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, rgba(247, 248, 250, 0) 0%, #f7f8fa 37%);
      .text {
        cursor: pointer;
        font-family: PingFang SC;
        font-size: 12px;
        line-height: 16px;
        color: #248df5;
      }
    }
  }

  .footer {
    padding: 12px 16px;
    text-align: center;

    .el-button {
      width: 100%;
    }
  }
}
:deep(.el-drawer__body) {
  padding: 0;
  overflow-y: hidden;
}
.empty-text {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #323233;
}

.content-warning {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  margin-bottom: 12px;

  .warning-icon {
    font-size: 14px;
    margin-right: 6px;
  }

  .warning-text {
    color: #d48806;
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>
